/*!
 * Load @corefact/toolchain/polyfills and any other needed polyfills.
 *
 * Inject custom @corefact/toolchain polyfills!
 */
import { Inject } from '@corefact/toolchain/polyfills';
Inject().then((list) => {
    console.log(`Applied toolchain polyfills: ${Object.keys(list).join(', ')}`)
}).catch(() => console.log('No toolchain polyfills applied!'));
